module.exports = __webpack_public_path__ + "static/media/XTZ.9379cdb3.svg";